(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["halte-photo-review-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const previous = event.target.closest('[data-halte-photo-prev]');
    const next = event.target.closest('[data-halte-photo-next]');

    if (!previous && !next) return;

    const slider = event.target.closest('[data-halte-photo-reviews]');
    if (!slider) return;

    const track = slider.querySelector('.halte-photo-reviews__track');
    if (!track) return;

    const direction = next ? 1 : -1;
    const cards = Array.prototype.slice.call(track.querySelectorAll('.halte-photo-reviews__card'));
    if (!cards.length) return;

    const currentIndex = Math.round(track.scrollLeft / track.clientWidth);
    let nextIndex = currentIndex + direction;

    if (nextIndex >= cards.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = cards.length - 1;

    track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["halte-priority-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const addBusinessDays = (date, days) => {
      const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      let added = 0;

      while (added < days) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();

        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }

      return result;
    };

    const formatDate = (date) => {
      const useShortMonth = window.matchMedia('(max-width: 480px)').matches;
      return new Intl.DateTimeFormat('fr-FR', {
        weekday: 'short',
        day: 'numeric',
        month: useShortMonth ? 'short' : 'long',
      }).format(date);
    };

    document.querySelectorAll('.halte-priority-delivery').forEach((block) => {
      const today = new Date();
      const start = block.querySelector('[data-halte-delivery-start]');
      const end = block.querySelector('[data-halte-delivery-end]');

      if (start) {
        start.textContent = formatDate(addBusinessDays(today, 3));
      }

      if (end) {
        end.textContent = formatDate(addBusinessDays(today, 5));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["halte-stock-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const toNumber = (value, fallback) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    document.querySelectorAll('[data-stock-progress]').forEach((root) => {
      const start = Math.round(toNumber(root.dataset.stockStart, 694));
      const total = Math.max(1, Math.round(toNumber(root.dataset.stockTotal, 1000)));
      const interval = Math.max(1, toNumber(root.dataset.stockInterval, 20)) * 1000;
      const minStep = Math.max(0, Math.round(toNumber(root.dataset.stockMin, 1)));
      const maxStep = Math.max(minStep, Math.round(toNumber(root.dataset.stockMax, 2)));
      const canAnimate = root.dataset.stockAnimate === 'true';
      const storageKey = `halte-stock-progress:${window.location.pathname}:${root.dataset.stockKey || 'default'}`;
      const currentEl = root.querySelector('[data-stock-current]');
      const totalEl = root.querySelector('[data-stock-total]');

      let current = clamp(start, 0, total);

      try {
        const stored = Number(window.localStorage.getItem(storageKey));
        if (Number.isFinite(stored)) {
          current = clamp(Math.max(current, Math.round(stored)), 0, total);
        }
      } catch (error) {
        /* localStorage can be unavailable in private browsing. */
      }

      const render = () => {
        const progress = clamp((current / total) * 100, 0, 100);
        root.style.setProperty('--halte-stock-progress', `${progress}%`);
        if (currentEl) currentEl.textContent = String(current);
        if (totalEl) totalEl.textContent = String(total);
      };

      render();

      if (!canAnimate || current >= total || maxStep === 0) return;

      window.setInterval(() => {
        if (current >= total) return;

        const step = minStep + Math.floor(Math.random() * (maxStep - minStep + 1));
        current = clamp(current + step, 0, total);
        render();

        try {
          window.localStorage.setItem(storageKey, String(current));
        } catch (error) {
          /* localStorage can be unavailable in private browsing. */
        }
      }, interval);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
